import AuthLayout from '@/layouts/AuthLayout';
import { SelfServiceGate } from '@/lib/self-service/components/SelfServiceGate';
import { SelfServiceSignupContent } from '@/lib/self-service/components/SelfServiceSignupContent';

export default function GetStartedPage() {
  return (
    <SelfServiceGate requireAuth={false}>
      <AuthLayout title='Create your account'>
        <SelfServiceSignupContent />
      </AuthLayout>
    </SelfServiceGate>
  );
}
